export class DeleteUserAdditionalEmail {
    static readonly type = '[User] DeleteUserAdditionalEmail';

    constructor(public payload: string) {}
}
